import { Link } from "react-router-dom";

const stats = [
  { value: "36,000+", label: "收录影片", icon: "ri-film-line" },
  { value: "12,800+", label: "剧集资源", icon: "ri-tv-2-line" },
  { value: "8,600+", label: "影视资讯", icon: "ri-newspaper-line" },
  { value: "99%", label: "影迷好评", icon: "ri-heart-3-line" },
];

const features = [
  {
    icon: "ri-database-2-line",
    title: "海量资源索引",
    desc: "覆盖电影、电视剧、综艺与纪录片，信息持续更新，查找更高效。",
  },
  {
    icon: "ri-filter-3-line",
    title: "多维精准筛选",
    desc: "按类型、地区、年份与热度排序，快速锁定你想看的那一部。",
  },
  {
    icon: "ri-star-smile-line",
    title: "个性化推荐",
    desc: "结合评分与口碑，为你呈上值得一看的影片与剧集推荐。",
  },
];

export default function SiteIntro() {
  return (
    <section className="mt-12 w-full bg-background-100 py-12 md:mt-16 md:py-16">
      <div className="container-page">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-600">
              <i className="ri-information-line" />
              关于四虎网站
            </span>
            <h2 className="mt-4 text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              一个为影迷而生的影视信息聚合平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              四虎网站汇聚高清电影与电视剧的详细资料，提供分类检索、影片介绍、评分口碑与最新影视资讯。
              我们希望通过清晰的分类与贴心的推荐，帮助每一位观众更快找到心仪的作品。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/about"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-team-line" />
                了解我们
              </Link>
              <Link
                to="/search"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-search-line" />
                开始找片
              </Link>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 md:gap-4">
            {stats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${stat.icon} text-xl`} />
                </span>
                <p className="mt-3 text-xl font-bold text-foreground-950 md:text-2xl">{stat.value}</p>
                <p className="mt-0.5 text-xs text-foreground-500 md:text-sm">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                <i className={`${feature.icon} text-xl`} />
              </span>
              <div>
                <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{feature.title}</h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-500 md:text-sm">{feature.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}